<template>
  <div>
    <card title="Payouts" :subtitle="''">
      <div>
        <label>XTM wallet balance: </label> &nbsp; ${{ $store.getters.paymentCardProviders[0] ? $store.getters.paymentCardProviders[0].walletBalance : 'N/A' }}
        <br><br>
        <Payouts-Table hideCompany/>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  name: 'Payouts-Card'
}
</script>

<style>

</style>